module.exports = __webpack_public_path__ + "img/gold4.7e3782df.png";